import React from 'react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import EventBusyOutlinedIcon from '@mui/icons-material/EventBusyOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import styles from './PlanStatusBanner.module.css';

const ICONS = {
  error: ErrorOutlineIcon,
  warning: EventBusyOutlinedIcon,
  offer: LocalOfferOutlinedIcon,
};

const TONE_CLASS = {
  error: styles.error,
  offer: styles.offer,
};

/**
 * Faixa de situação da assinatura com uma ação (pagamento pendente,
 * cancelamento agendado) ou aviso sem ação (oferta de reconquista do teste vencido).
 */
const PlanStatusBanner = ({ tone = 'warning', title, text, actionLabel, onAction, actionDisabled, actionTitle }) => {
  const Icon = ICONS[tone] || ICONS.warning;
  return (
    <div className={`${styles.banner} ${TONE_CLASS[tone] || styles.warning}`}>
      <Icon className={styles.icon} />
      <div className={styles.content}>
        <strong className={styles.title}>{title}</strong>
        <p className={styles.text}>{text}</p>
      </div>
      {actionLabel && (
        <button
          type="button"
          className={styles.action}
          onClick={onAction}
          disabled={actionDisabled}
          title={actionTitle}
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default PlanStatusBanner;
